import React, { useEffect, useState } from "react";
import { api, formatINR } from "@/lib/api";
import { toast } from "sonner";
import { DisclaimerBanner } from "@/components/DisclaimerBanner";
import { useLang } from "@/contexts/LanguageContext";

export default function LenderInterest() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t, tv } = useLang();
  const load = async () => { const { data } = await api.get("/borrower/lender-interests"); setItems(data); setLoading(false); };
  useEffect(() => { load(); }, []);

  const accept = async (id) => {
    try {
      await api.post(`/borrower/lender-interests/${id}/accept`);
      toast.success("Consent granted & application created");
      await load();
    } catch (e) { toast.error("Failed"); }
  };
  const decline = async (id) => {
    try { await api.post(`/borrower/lender-interests/${id}/decline`); toast.success("Declined"); await load(); } catch (e) { toast.error("Failed"); }
  };

  return (
    <div className="space-y-6" data-testid="lender-interests-page">
      <div>
        <h1 className="text-3xl font-bold text-slate-900 brand-heading">{t("li_title")}</h1>
        <p className="text-slate-600 mt-1 text-sm">{t("li_sub")}</p>
      </div>
      {loading ? <div className="text-slate-500">{t("loading")}</div> : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {items.map((it) => (
            <div key={it.id} className="p-6 rounded-lg border border-slate-200 bg-white card-hover" data-testid={`interest-${it.id}`}>
              <div className="flex items-start justify-between">
                <div>
                  <div className="text-xs uppercase tracking-widest text-slate-500">{t("li_tag")}</div>
                  <div className="text-lg font-semibold text-slate-900 brand-heading">{it.lender_name}</div>
                </div>
                <span className="rounded-full bg-slate-100 border border-slate-200 text-xs px-2 py-0.5" data-testid={`interest-status-${it.id}`}>{t(`st_${it.status}`)}</span>
              </div>
              <div className="mt-4 grid grid-cols-2 gap-3 text-xs">
                <div><div className="text-slate-500">{t("li_amount")}</div><div className="font-semibold text-slate-900">{formatINR(it.indicative_amount_min)} – {formatINR(it.indicative_amount_max)}</div></div>
                <div><div className="text-slate-500">{t("li_rate")}</div><div className="font-semibold text-slate-900">{it.indicative_rate_min}% – {it.indicative_rate_max}%</div></div>
                <div><div className="text-slate-500">{t("li_tenure")}</div><div className="font-semibold text-slate-900">{it.indicative_tenure_months} {t("mo")}</div></div>
                <div><div className="text-slate-500">{t("li_morat")}</div><div className="font-semibold text-slate-900">{it.indicative_moratorium_months} {t("mo")}</div></div>
                <div><div className="text-slate-500">{t("li_fee")}</div><div className="font-semibold text-slate-900">{it.processing_fee_pct}%</div></div>
                <div><div className="text-slate-500">CGTMSE</div><div className="font-semibold text-slate-900">{tv(it.cgtmse_consideration)}</div></div>
                <div className="col-span-2"><div className="text-slate-500">{t("li_collat")}</div><div className="font-semibold text-slate-900">{tv(it.collateral_expectation)}</div></div>
                <div className="col-span-2"><div className="text-slate-500">{t("li_docs")}</div><div className="font-semibold text-slate-900">{(it.additional_documents || []).map(tv).join(", ") || "—"}</div></div>
              </div>
              <div className="mt-4 text-[11px] text-amber-800 bg-amber-50 border border-amber-200 rounded-md p-2 leading-relaxed">
                {t("li_note_a")} <strong>{t("li_note_b")}</strong>{t("li_note_c")}
              </div>
              {it.status === "posted" && (
                <div className="mt-4 flex gap-2">
                  <button onClick={() => accept(it.id)} data-testid={`accept-${it.id}`} className="flex-1 rounded-md bg-slate-900 hover:bg-slate-800 text-white px-4 py-2 text-sm font-semibold">{t("li_accept")}</button>
                  <button onClick={() => decline(it.id)} data-testid={`decline-${it.id}`} className="rounded-md border border-slate-300 px-4 py-2 text-sm">{t("li_decline")}</button>
                </div>
              )}
            </div>
          ))}
          {items.length === 0 && <div className="text-sm text-slate-500">{t("li_none")}</div>}
        </div>
      )}
      <DisclaimerBanner compact />
    </div>
  );
}
